<div *ngIf="isLoading" class="loader" ></div>
<!-- (click)="stopLoader()" -->